<template>
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <v-flex>
                <div class="text-center">
                  <v-text-field-simplemask
                      v-model="phoneNumber"
                      label="Phone number"

                      v-bind:properties="{
                        title: true,
                      clearable: true,
                      'prepend-icon': 'phone'
                     }"
                      v-bind:options="{
                      inputMask: '(###) ###-####',
                      outputMask: '###########',
                      alphanumeric: true}"
                  />
                </div>
                <div class="text-center" v-if="phoneNumber">
                  <v-btn
                      :loading="loading"
                      :disabled="loading"
                      color="blue"
                      class="ma-2 white--text"
                      @click="addNewContactDialog()"
                      rounded
                      v-if="phoneNumber.length === 10"
                  >
                    Text or Add Contact
                    <v-icon right dark>person</v-icon>
                  </v-btn>
                  <v-btn
                      v-if="phoneNumber.length === 10"
                      class="green"
                      @click="callNumber"
                      large
                      icon>
                    <v-icon class="white--text">call</v-icon>
                  </v-btn>
                </div>
        </v-flex>
      </v-layout>
    </v-container>

</template>
<script>

export default {

  data: () => ({
    phoneNumber: '',
    numberValid: false
  }),
  computed: {
    user () {
      return this.$store.getters.user
    },
    error () {
      return this.$store.getters.error
    },
    loading () {
      return this.$store.getters.loading
    }
  },
  watch: {
    phoneNumber (value) {
      if(value.length === 10) {
        this.$emit('numberFound', value)
        this.numberValid = true
      } else {
        this.numberValid = false
      }
    }
  },
  created () {
  },
  methods: {
    addNewContactDialog () {
      return this.$emit('contactDialogValue', true)
    },
    numberInput (v) {
      console.log(this.phoneNumber)
      if (this.phoneNumber) {
        if (this.phoneNumber.length < 10) {
          if(this.phoneNumber === '') {
            this.phoneNumber = v.toString()
          } else {
            this.phoneNumber += v.toString()
          }
        }
      }


    },
    clearPad () {
      this.phoneNumber = ''
    },
    callNumber() {
      // emitt number to number portal
      if(this.phoneNumber.length === 10) {
        this.$emit('callFromDialPad', this.phoneNumber)
      } else {
        this.notValidTooltip = true
      }
    },
    removeNumber () {
      if (this.phoneNumber !== '') {
        this.phoneNumber = this.phoneNumber.substring(0, this.phoneNumber.length - 1)
      }
    },
    onDismissed () {
      this.$store.dispatch('clearError')
    }
  }

}
</script>
